import React, { useState, useEffect, Fragment } from "react";
import Support1Img from "../../images/newHome/support_img_1.png"
import Support2Img from "../../images/newHome/support_img_2.png"
import Support3Img from "../../images/newHome/support_img_3.png"
import Support4Img from "../../images/newHome/support_img_4.png"
import ThemeButton from "./ThemeButton";
import SectionTitle from "./SectionTitle";

function SupportSection() {
    return (
        <Fragment>
            <div className="container lg:px-20 lg:pt-20 lg:pb-16 p-0 text-center">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[64px]">
                    {/* left section */}
                    <div className="p-4 lg:p-0 lg:px-8">
                        <SectionTitle
                            size="font-inter text-2xl xl:text-[44px] lg:text-[44px]"
                            weight="font-bold"
                            color="text-titleColor"
                            align="text-start"
                            className="leading-tight"
                        >
                            Who We Are & What We Stand For
                        </SectionTitle>
                        <p className="text-start lg:text-lg text-base lg:mt-5 mt-4 text-textColor">Telcron is dedicated to making compliance testing seamless and efficient. Our team of experts works with global labs to help businesses achieve regulatory approvals faster.</p>
                        <div className="text-start lg:mt-8 mt-5">
                            <ThemeButton
                                bgColor="bg-primaryColor"
                                textColor="text-white"
                                padding="px-6 py-3"
                                size="text-lg"
                                rounded="rounded-none"
                                className="leading-[28px] cursor-pointer"
                            >
                                Learn More About Us
                            </ThemeButton>
                        </div>
                    </div>
                    {/* right section */}
                    <div className="grid grid-cols-1 lg:px-8 gap-4 mb-2 lg:mb-0 justify-items-center items-start overflow-hidden">
                        <div className="grid grid-cols-[120px_160px_160px_120px] gap-4 mt-4 items-start">
                            {/* Left Offset */}
                            <div></div>

                            {/* First Image */}
                            <div>
                                <img
                                    className="w-full h-auto object-cover"
                                    src={Support1Img}
                                    alt="Support1"
                                />
                            </div>

                            {/* Second Image (was empty before, now gets an image) */}
                            <div>
                                {/* <img
                                    className="w-full h-auto object-cover"
                                    src={Support2Img}
                                    alt="Support2"
                                /> */}
                            </div>

                            {/* Right Offset */}
                            <div></div>
                        </div>

                        {/* Grid of 3 images */}
                        <div className="grid grid-cols-[192px_160px_192px] gap-4 justify-items-center items-start overflow-hidden">
                            <div className="w-[192px]">
                                <img
                                    className="w-full h-auto object-cover"
                                    src={Support2Img}
                                    alt="Support2"
                                />
                            </div>
                            <div className="w-[160px] h-[240px]">
                                <img
                                    className="w-full h-full object-cover"
                                    src={Support3Img}
                                    alt="Support3"
                                />
                            </div>
                            <div className="w-[192px] h-[176px]">
                                <img
                                    className="w-full h-full object-cover"
                                    src={Support4Img}
                                    alt="Support4"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )

}
export default SupportSection;